import { Account } from './index';

export const accountToEventModel = (account: Account) => ({
  subscription: {
    name: account?.tier?.name,
    frequency: account?.subscription?.price?.frequency,
    amount: account?.subscription?.price?.amount,
  },
});
